import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-manual-update-dialog',
  templateUrl: './manual-update-dialog.component.html',
  styleUrls: ['./manual-update-dialog.component.scss']
})
export class ManualUpdateDialogComponent implements OnInit {
  optionList;
  selectedOption;
  smsDetails;
  pollOptions;

  constructor(
    public dialogRef: MatDialogRef<ManualUpdateDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) { 
    this.optionList = data.optionList;
    this.selectedOption = data.selectedOption;
    this.smsDetails = data.smsDetails;
    this.pollOptions = data.pollOptions;
    debugger;
   }

  ngOnInit(): void {
  }

  manualUpdate(){
    let matchedOption = this.pollOptions.filter(e => e.name === this.selectedOption);
    console.log(matchedOption)
    let updatedMatchedOptionValue = { "parsed_response":this.selectedOption,"matched_option":matchedOption[0].id } 
    console.log(updatedMatchedOptionValue)
    this._apiService.manualUpdatePollResult(updatedMatchedOptionValue, this.smsDetails.id).subscribe(res => {
       if (res) {
          debugger;
          console.log( res);
          this.dialogRef.close();
       }
    },
    (error)=>{
       this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
       this.dialogRef.close();
    });
 }


  onClickNo(){
    this.dialogRef.close();
  }

}
